import { motion } from 'framer-motion';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AccountSettings } from './components/AccountSettings';
import { SecuritySettings } from './components/SecuritySettings';
import { APISettings } from './components/APISettings';
import { SiteHeader } from '@/components/site-header';
import { User, Shield, Key } from 'lucide-react';

export default function SettingsPage() {
    return (
        <div className="flex flex-col h-full">
            <SiteHeader
                title="Settings"
                subtitle="Manage your account settings and preferences"
            />

            <div className="flex-1 overflow-y-auto">
                <div className="px-4 py-6 md:px-8 md:py-8">
                    <Tabs defaultValue="account" className="space-y-4">
                        <div className="flex items-center justify-between">
                            <TabsList className="h-11">
                                <TabsTrigger value="account" className="gap-2 px-4">
                                    <User className="h-4 w-4" />
                                    Account
                                </TabsTrigger>
                                <TabsTrigger value="security" className="gap-2 px-4">
                                    <Shield className="h-4 w-4" />
                                    Security
                                </TabsTrigger>
                                <TabsTrigger value="api" className="gap-2 px-4">
                                    <Key className="h-4 w-4" />
                                    API
                                </TabsTrigger>
                            </TabsList>
                        </div>

                        <TabsContent value="account" className="mt-0">
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <AccountSettings />
                            </motion.div>
                        </TabsContent>

                        <TabsContent value="security" className="mt-0">
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <SecuritySettings />
                            </motion.div>
                        </TabsContent>

                        <TabsContent value="api" className="mt-0">
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <APISettings />
                            </motion.div>
                        </TabsContent>
                    </Tabs>
                </div>
            </div>
        </div>
    );
}
